export enum PortfolioEvents {
  SWITCH_GRAPH_PERIOD = 'PORTFOLIO:switch_graph_period',
  CLICKED_POSITION = 'PORTFOLIO:clicked_position',
  CLICKED_WATCHLIST_ASSET = 'PORTFOLIO:clicked_watchlist_asset',
}
